import Container from "./TaskDetailsStyle";
import Spinner from "../../shared/Spinner/Spinner";
import * as utils from "../../utils";
import api from "../../services/api";

import { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle";


export default function TaskDetails(props) {

  const [loading, setLoading] = useState(false);
  const [errorEditing, setErrorEditing] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [name, setName] = useState("");
  const [orderValue, setOrderValue] = useState("0");
  const [percentage, setPercentage] = useState("0");

  const enterpriseId = props.match.params.enterpriseId;
  const taskId = props.match.params.taskId;

  const creatingNew = taskId < 0;

  useEffect(() => {
    if (!creatingNew)
      LoadTaskDetails();
  }, []);

  async function LoadTaskDetails() {
    setLoading(true);
    try {
      const result = await api.get(`enterprises/${enterpriseId}/tasks`);
      if (!result.data.success) {
        setLoading(false);
        setErrorMessage(result.data.error);
        return;
      }
      const tasks = result.data.tasks;
      const task = tasks.find(task => task.id === parseInt(taskId));

      if (!task) {
        setErrorEditing(true);
        setErrorMessage("Não foi possível pegar os dados da tarefa");
        console.error(`Não há tarefa com id: ${taskId} na lista de tarefas`);
        return;
      }
      setName(task.name);
      setOrderValue(task.orderValue);
      setPercentage(task.percentage);
      setLoading(false);
    }
    catch (error) {
      setLoading(false);
      setErrorEditing(true);
      setErrorMessage("Não foi possível pegar os dados da tarefa");
      console.error(error);
    }
  }

  async function OnSubmit() {
    const data = {
      name,
      orderValue,
      percentage,
    };
    setLoading(true);
    try {
      const request = creatingNew ? api.post(`/enterprises/${enterpriseId}/tasks`, data) : api.put(`/enterprises/${enterpriseId}/tasks/${taskId}`, data);
      const result = await request;
      setLoading(false);
      if (result.data.success)
        props.history.goBack()
      else {
        setErrorEditing(true);
        const message: string = result.data.message;
        if (message && message.includes("Out of range value for column 'orderValue'"))
          setErrorMessage("Valor inválido para ordem da tarefa");
        else
          setErrorMessage(JSON.stringify(result.data));
      }

    }
    catch (error) {
      setErrorEditing(true);
      setErrorMessage("Não foi possível alterar tarefa, erro no servidor!");
      console.error(error);
      setLoading(false);
    }
  }

  function OnChangePercentage(newPercentage) {
    setPercentage(utils.Clamp(0, newPercentage, 100).toString());
  }

  return (
    <Container>
      <PageTitle title="Tarefa da Obra" />
      <div>
        <div>
          <button onClick={() => props.history.goBack()} className="btn btn-secondary">Voltar</button>
        </div>
        <Spinner spinning={loading} />
        {errorEditing && <p className="alert">Erro: {errorMessage}</p>}
        <main>
          <div className="panel">
            <form className="main-form" onSubmit={(e) => { e.preventDefault(); OnSubmit(); }}>
              <h2>Edição de Tarefa</h2>
              <div>
                <label>Tarefa:</label>
                <input
                  autoComplete="product-name"
                  disabled={loading}
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
              </div>

              <div>
                <label>Ordem:</label>
                <input
                  type="number"
                  min="0"
                  max="100"
                  autoComplete="product-name"
                  disabled={loading}
                  value={orderValue}
                  onChange={e => setOrderValue(e.target.value)}
                />
              </div>

              <div>
                <label>Porcentagem: </label>
                <input
                  type="number"
                  min="0"
                  max="100"
                  disabled={loading}
                  value={percentage}
                  onChange={e => OnChangePercentage(e.target.value)}
                />
              </div>
              <button
                className="btn btn-success btn-lg mt-4"
                type="button"
                disabled={loading}
                onClick={e => {
                  e.preventDefault();
                  OnSubmit();
                }}>{creatingNew ?
                  "Adicionar" :
                  "Editar"}
              </button>
            </form>
          </div>
        </main>
      </div>
    </Container >
  );
}